import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>({...props.rowData})
  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )
  const inflationDefault = _.get(props.defaults, "tiInflation.inflationNamedItemId")
  const payoutOptions = _.map(
    _.get(props, "namedItems.payout"),
    item => {
      return {value: item.payoutid, label: item.code}
    }
  )
  const payoutDefault = _.get(props.defaults, "tiPayout.payoutNamedItemId")
  const amtDefault = props.defaults['lcAmtType']

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)

    _.set(nextData, "inputtype", "basic")
    _.set(nextData, "tenantcapitaldetail", null)
    _.set(nextData, "amttype", _.get(localCache, "amttype") || amtDefault)
    _.set(nextData, "inflationdetail", _.includes(_.get(localCache, "amttype"), "%") ? null : {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(localCache, "inflationdetail.inflationNamedItemId") || inflationDefault
    })
    _.set(nextData, "payoutdetail", {
      payoutMode: "namedItem",
      payoutNamedItemId: _.get(localCache, "payoutdetail.payoutNamedItemId") || payoutDefault
    })

    if(field === "inflationdetail.inflationNamedItemId") {
      nextData["inflationdetail"] = localCache["inflationdetail"] = {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      }
    } else if(field === "payoutdetail.payoutNamedItemId") {
      nextData["payoutdetail"] = localCache["payoutdetail"] = {
        payoutMode: "namedItem",
        payoutNamedItemId: val
      }
    } else if(field === "amttype") {
      _.includes(val, "%") ? _.set(nextData, "inflationdetail", null) : _.set(nextData, "inflationdetail", {
        inflationMode: "namedItem",
        inflationNamedItemId: inflationDefault
      })
      nextData[field] = localCache[field] = val
    } else {
      nextData[field] = localCache[field] = val
    }
    setData(localCache)
    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('tenantcapital', props.field)(field)(props.rowData, props)
  const unnested_attrs = (field) => field_attrs('tenantcapital')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput className="automated new-field" data={data} attrs={unnested_attrs} field="amtnew" readPrecision={4} writePrecision={4} persist={updateData} />
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput className="automated renewal-field" data={data} attrs={unnested_attrs} field="amtrenew" readPrecision={4} writePrecision={4} persist={updateData} />
        </div>
        <div>
        <label>Amt Type</label>
          <DropdownInput className="automated amt-type-field" data={data} attrs={attrs} default={amtDefault}
            field="amttype" options={[
              'Amt',
              'Amt/Area',
              '% of Rent',
              '% of Rent + Recovery',
              '% of Rent: Ignore Free',
              '% of Rent + Recovery: Ignore Free',
              '% of All Revenues'
            ]} persist={updateData} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} field="inflationdetail.inflationNamedItemId"
            default={inflationDefault}
            options={inflationOptions} persist={updateData} disabled={_.includes(_.get(data, "amttype"), "%")}
            attrs={attrs}/>
        </div>
        <div>
          <label>Payout</label>
          <DropdownInput className="automated" data={data} field="payoutdetail.payoutNamedItemId"
            default={payoutDefault}
            options={payoutOptions} persist={updateData}
            attrs={attrs}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic
